/*
 * Do not remove or alter the notices in this preamble.
 * This software code regards iO Custom Software.
 * Copyright © 2026 iO The Netherlands B.V. and/or its affiliates.
 * www.iodigital.com All rights reserved. License grant and user rights and obligations
 * according to applicable license agreement. Please contact legal@iodigital.com for
 * questions regarding license and user rights.
 */

import { StateCreator } from 'zustand';

import { GlobalComponentPropertiesTypes } from '@/types';

export const globalStorePropertiesStore: StateCreator<
  GlobalComponentPropertiesTypes
> = () => ({
  baseUrl: '',
  locale: 'en_US',
  country: 'US',
  debtor: '',
  product: '',
  productName: '',
  customerId: undefined,
});
